<div id="date-range-picker-root"
  class="date-range-picker-root"
  *transloco="let t"
  (click)="openDatepicker()">
  <form [formGroup]="range">
    <mat-date-range-input [rangePicker]="rangePicker"
      [max]="setMaxRange()">
      <input matStartDate readonly placeholder="dd/mm/yyyy" formControlName="start"/>
      <input matEndDate readonly placeholder="dd/mm/yyyy" formControlName="end"/>
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker startView="month" (closed)="emitDate()"></mat-date-range-picker>
  </form>
</div>
